<div class="panel">
  <div class="content">
    <ng-content></ng-content>
  </div>
</div>
